// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  GroupControlVariant,
  unionToGroupControlVariant,
  unionListToGroupControlVariant,
} from "./group-control-variant";
import {
  NormalGroupControl,
  NormalGroupControlT,
  verifyNormalGroupControl,
} from "./normal-group-control";
import {
  ValuedGroupControl,
  ValuedGroupControlT,
  verifyValuedGroupControl,
} from "./valued-group-control";

export class EscalatorGroupControlMessage implements flatbuffers.IUnpackableObject<EscalatorGroupControlMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EscalatorGroupControlMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEscalatorGroupControlMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: EscalatorGroupControlMessage,
  ): EscalatorGroupControlMessage {
    return (obj || new EscalatorGroupControlMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsEscalatorGroupControlMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: EscalatorGroupControlMessage,
  ): EscalatorGroupControlMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EscalatorGroupControlMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  controlType(): GroupControlVariant {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : GroupControlVariant.NONE;
  }

  control<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startEscalatorGroupControlMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addControlType(builder: flatbuffers.Builder, controlType: GroupControlVariant) {
    builder.addFieldInt8(0, controlType, GroupControlVariant.NONE);
  }

  static addControl(builder: flatbuffers.Builder, controlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, controlOffset, 0);
  }

  static endEscalatorGroupControlMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // control
    return offset;
  }

  static createEscalatorGroupControlMessage(
    builder: flatbuffers.Builder,
    controlType: GroupControlVariant,
    controlOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    EscalatorGroupControlMessage.startEscalatorGroupControlMessage(builder);
    EscalatorGroupControlMessage.addControlType(builder, controlType);
    EscalatorGroupControlMessage.addControl(builder, controlOffset);
    return EscalatorGroupControlMessage.endEscalatorGroupControlMessage(builder);
  }

  unpack(): EscalatorGroupControlMessageT {
    return new EscalatorGroupControlMessageT(
      this.controlType(),
      (() => {
        const temp = unionToGroupControlVariant(this.controlType(), this.control.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: EscalatorGroupControlMessageT): void {
    _o.controlType = this.controlType();
    _o.control = (() => {
      const temp = unionToGroupControlVariant(this.controlType(), this.control.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): EscalatorGroupControlMessageT {
    const t = new EscalatorGroupControlMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("control_type")) {
      t.controlType = this.controlType();
    }
    if (fieldSet.has("control")) {
      t.control = (() => {
        const temp = unionToGroupControlVariant(this.controlType(), this.control.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class EscalatorGroupControlMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public controlType: GroupControlVariant = GroupControlVariant.NONE,
    public control: NormalGroupControlT | ValuedGroupControlT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.control === null || this.control === undefined) {
      throw new Error('Required field "control" is not set');
    }
    const control = builder.createObjectOffset(this.control);

    return EscalatorGroupControlMessage.createEscalatorGroupControlMessage(
      builder,
      this.controlType,
      control,
    );
  }

  clone(): EscalatorGroupControlMessageT {
    const obj = new EscalatorGroupControlMessageT();
    obj.controlType = this.controlType;
    obj.control =
      this.control !== null && typeof (this.control as any).clone === "function"
        ? (this.control as any).clone()
        : this.control;
    return obj;
  }

  equals(other: EscalatorGroupControlMessageT): boolean {
    if (this.controlType !== other.controlType) return false;
    if (this.control !== null && other.control !== null) {
      if (typeof (this.control as any).equals === "function") {
        if (!(this.control as any).equals(other.control)) return false;
      } else if (this.control !== other.control) return false;
    } else if (this.control !== other.control) return false;
    return true;
  }
}

export function verifyEscalatorGroupControlMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "control");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NormalGroupControl
            {
              const o = verifier.readInt32(pos);
              verifyNormalGroupControl(verifier, pos + o);
            }
            break;
          case 2: // ValuedGroupControl
            {
              const o = verifier.readInt32(pos);
              verifyValuedGroupControl(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "control");
  } finally {
    verifier.popDepth();
  }
}
